import React, { useState } from 'react';
import { CardBody, CardFooter } from './ui/Card';
import Button from './ui/Button';
import Modal from './ui/Modal';
import './Modal.css';

const TITLE_ID = 'alert-modal-title';

function AlertModal({ message, onClose, type = 'info', copyUrl = null }) {
    // type can be: 'info', 'success', 'error', 'warning'
    // copyUrl: optional URL to show a copy button for
    const [copied, setCopied] = useState(false);

    const handleCopyUrl = async () => {
        if (!copyUrl) return;

        let success = false;

        // Try modern clipboard API first
        if (navigator.clipboard && navigator.clipboard.writeText) {
            try {
                await navigator.clipboard.writeText(copyUrl);
                success = true;
            } catch (err) {
                // Clipboard API failed, will try fallback
            }
        }

        // Fallback to execCommand for HTTP or older browsers
        if (!success) {
            try {
                const textArea = document.createElement('textarea');
                textArea.value = copyUrl;
                textArea.style.position = 'fixed';
                textArea.style.left = '-999999px';
                textArea.style.top = '-999999px';
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                success = document.execCommand('copy');
                document.body.removeChild(textArea);
            } catch (err) {
                // Fallback copy failed
            }
        }

        if (success) {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }
    };

    const getVariantStyles = () => {
        switch (type) {
            case 'success':
                return {
                    icon: '✓',
                    title: 'Success',
                    buttonVariant: 'success'
                };
            case 'error':
                return {
                    icon: '✗',
                    title: 'Error',
                    buttonVariant: 'danger'
                };
            case 'warning':
                return {
                    icon: '⚠',
                    title: 'Warning',
                    buttonVariant: 'warning'
                };
            default:
                return {
                    icon: 'ℹ',
                    title: 'Info',
                    buttonVariant: 'primary'
                };
        }
    };

    const styles = getVariantStyles();

    return (
        <Modal
            onClose={onClose}
            labelledBy={TITLE_ID}
            overlayClassName="modal-backdrop"
            className="modal-card"
        >
            <CardBody>
                <div className="modal-header">
                    <div className={`modal-icon modal-icon--${type}`}>
                        {styles.icon}
                    </div>
                    <h3 className="modal-title" id={TITLE_ID}>{styles.title}</h3>
                </div>
                <p className="modal-message modal-message--wrap">{message}</p>
            </CardBody>
            <CardFooter>
                {copyUrl && (
                    <Button
                        variant="secondary"
                        onClick={handleCopyUrl}
                    >
                        {copied ? 'Copied!' : 'Copy URL'}
                    </Button>
                )}
                <Button
                    variant={styles.buttonVariant}
                    onClick={onClose}
                    autoFocus
                >
                    OK
                </Button>
            </CardFooter>
        </Modal>
    );
}

export default AlertModal;
